import React from "react";

import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import deLocale from "@fullcalendar/core/locales/de";

const CustomCalendar = ({ eventList }) => {
  /* Custom event content only displaying title and time */
  function renderEventContent(eventInfo) {
    return (
      <>
        <b className="event-title">{eventInfo.event.title}</b>
        <br />
        <i className="event-time">{eventInfo.timeText}</i>
      </>
    );
  }

  return (
    /* Cutomized full calendar */
    <FullCalendar
      height={"100%"}
      viewClassNames={"calendar-view"}
      events={eventList}
      eventContent={renderEventContent}
      eventClassNames={"calendar-event"}
      noEventsContent={
        "Es sind keine Einträge für den ausgewählten Zeitraum vorhanden."
      }
      noEventsClassNames={"no-events"}
      plugins={[timeGridPlugin, listPlugin]}
      initialView="timeGridDay"
      locale={deLocale}
      nowIndicator={true}
      nowIndicatorClassNames={"now-indicator"}
      weekends={true}
      hiddenDays={[0]} // hides sundays in calendar
      scrollTime={"08:00:00"}
      slotDuration={"00:30:00"}
      slotLabelFormat={{
        hour: "2-digit",
        minute: "2-digit",
        omitZeroMinute: false,
      }}
      allDaySlot={true}
      allDayContent={"Heute"}
      timeZone={"UTC"}
      titleFormat={{ year: "numeric", month: "short", day: "numeric" }}
      dayHeaderClassNames="calendar-header"
      headerToolbar={{
        left: "listWeek,timeGridWeek,timeGridDay",
        center: "title",
        right: "",
      }}
      footerToolbar={{
        left: "",
        center: "",
        right: "prev,today,next",
      }}
    />
  );
};

export default CustomCalendar;
